<template>
    <div class="uk-width-medium">

        <ul class="uk-flex-center" uk-tab>
            <li><a>Login</a></li>
            <li><a>Sign Up</a></li>
        </ul>

        <div class="uk-switcher uk-margin">

            <!-- Login-->
            <div>
                <form class="uk-form-stacked uk-grid-small uk-child-width-1-1" uk-grid>

                    <div>
                        <label class="uk-form-label" for="email">Email</label>
                        <div class="uk-form-controls uk-inline uk-width-1-1">
                            <span class="uk-form-icon" uk-icon="icon: mail"></span>
                            <input v-validate="'required|email'" v-model="formData.User.email" name="Email" class="uk-input" id="email" type="email">
                            <span class="help is-danger" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                        </div>
                    </div>

                    <div>
                        <label class="uk-form-label" for="password">Password</label>
                        <div class="uk-form-controls uk-inline uk-width-1-1">
                            <input
                                    v-model="formData.User.password"
                                    v-validate="'required'"
                                    class="uk-input"
                                    id="password"
                                    type="password"
                                    name="password"
                            >
                            <span class="help is-danger" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                        </div>
                    </div>

                    <div>
                        <button @click.prevent="login" class="uk-margin uk-button uk-button-primary uk-width-1-1">Login</button>
                    </div>

                    <div class="uk-flex uk-flex-between">
                        <label><input class="uk-checkbox" type="checkbox" checked> Remember me</label>
                        <a href="#">Forgot Password?</a>
                    </div>

                </form>
            </div>

            <!-- Sign Up -->
            <sign-up></sign-up>

        </div>


    </div>
</template>
<script>
    import SignUp from './SignUp.vue';
    export default {
        components: {
          SignUp
        },
        data(){
            return {
                formData: {
                    User: {
                        email: '',
                        password: '',
                    }
                }
            }
        },
        methods: {
            login(){
                this.$validator.validateAll().then(() => {
                    this.$http.post('/users/login', this.formData).then(response => {
                        // success callback
                        console.log(response)
                    }, response => {
                        // error callback
                    });
                }).catch(() => {

                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Login.vue?0dcfadf6